import React from 'react';


export default class InfraRoutesResultsTable extends React.Component {
	render() {
		var infradata = this.props.routes
		var infralist = Object.keys(infradata).map(function(key) {
	          return (
			            infradata[key]
			          );
				 })
		
		infralist.sort(   function(a,b) {return (a.priority < b.priority ) ? 1 : ((b.priority  < a.priority ) ? -1 : 0);}     )
		var tableitems = infralist.map((infraroute) =>
		<tr key={infraroute.type} className={(infraroute.walktime == null ? 'grey' : '')}>
        <td className={(infraroute.walktime == null ? 'nicht-erreichbar bold' : 'erreichbar bold')}>{(infraroute.walktime == null ? '\u274C' : '\u2714')}</td><td className="bold">{infraroute.type}{infraroute.from_osm ? <span className="" data-tip="...OpenStreetMap-Daten"> [?]</span> : ''}</td>
        <td>{infraroute.targetname}</td><td>{infraroute.walktime !== null ? 'ca. ' + Math.round(infraroute.walktime) + ' Min.' : '>15 Min.'}</td>
        </tr>
		);
		return (
				<div className="table-responsive">
				 <table className="table infratable">
				 <thead><tr><th></th><th></th><th>Name</th><th>Gehzeit</th></tr></thead>
				 <tbody>
				 {tableitems}
	    		  </tbody>
	    		  </table>
			  <hr></hr>
			  <p><strong>Nächstes Zentrum: {this.props.traveltimescenter.name}</strong></p>
			  <p><abbr title="Öffentlicher Verkehr">ÖV</abbr>-Reisezeit: <strong>{this.props.traveltimescenter.oev} Min.</strong>, <abbr title="Motorisierter Individualverkehr">MIV</abbr>-Reisezeit: <strong>{this.props.traveltimescenter.iv} Min.</strong></p>
	    		  </div>
	    		 
		)
	}
}





// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/infraresults/infratable.js